import { injectable } from 'tsyringe'
import { AdditionalInfoReportApiRepository } from '@/app/repositories/api/AdditionalInfoReportApiRepository'
import {
  AdditionalInfoReport,
  Export,
} from '@/domain/entities/AdditionalInfoReport'

@injectable()
export class AdditionalInfoReportPresenter {
  private repository: AdditionalInfoReportApiRepository

  constructor(repository: AdditionalInfoReportApiRepository) {
    this.repository = repository
  }

  public loadAdditionalInfoReport(
    params: Object
  ): Promise<AdditionalInfoReport> {
    return this.repository.getAll(params)
  }
  public loadExport(params: Object): Promise<Export> {
    return this.repository.getExport(params)
  }
}
